import type { ValuesOf } from '@do/utils/types';

import type { IconNames } from '@shared/ui/icon';

export const NoDataType = {
  // Artworks: 'artworks',
  // Artists: 'artists',
  // Documents: 'documents',
  // Auctions: 'auctions',
  // Transactions: 'transactions',
  // Notifications: 'notifications',
  // Locations: 'locations',
  // Requests: 'requests',
  Collection: 'collection',
} as const;

export type NoDataType = ValuesOf<typeof NoDataType>;

export type NoDataContent = {
  icon: IconNames;
  message: string;
};

export const noDataTypes = {
  // artworks: {
  //   icon: 'no-artworks',
  //   message:
  //     'Please create a detailed record of an artwork,<br/>submit it for verification and digitization, and then list it for sale.',
  // }
  collection: {
    icon: 'no-collection',
    message: 'Your Digital Originals collection is empty.<br/>Explore our art and choose some amazing pieces to add!',
  },
} satisfies Record<NoDataType, NoDataContent>;

export const getDataByType = (type: NoDataType, total: number, search: string, filters: string): NoDataContent => {
  if (!search && !filters && !total) {
    return noDataTypes[type];
  }

  // if (!total && filters && type === NoDataType.Notifications) {
  //   return {
  //     icon: noDataTypes[type].icon,
  //     message: 'There are no read notifications here',
  //   };
  // }

  // if (!total && (search || filters)) {
  //   return {
  //     icon: 'search',
  //     message: `No ${type} were found. Please try another query.`,
  //   };
  // }

  // return {
  //   icon: 'search',
  //   message: `No ${type} were found. Please try another query.`,
  // };
};
